// src/data/servicesData.js

import { Wrench, Gauge, Droplets, Disc, ShieldAlert, Zap } from 'lucide-react';

export const servicesData = [
  {
    slug: "periyodik-bakim", // URL'de görünecek kısım
    title: "Periyodik Bakım",
    icon: <Droplets size={60} />,
    shortDesc: "Yağ değişimi, filtre kontrolü ve genel sıvı bakımları.",
    content: `
      <h3>Motosiklet Periyodik Bakımı Neden Önemlidir?</h3>
      <p>Motosikletinizin uzun ömürlü olması ve performansını ilk günkü gibi koruması için periyodik bakım hayati önem taşır. AKC Motor olarak, üretici firmanın belirlediği standartlarda yağ değişimi, yağ filtresi değişimi ve hava filtresi temizliği yapıyoruz.</p>
      
      <h3>Periyodik Bakım Paketimizde Neler Var?</h3>
      <ul>
        <li>Motul veya Castrol tam sentetik motor yağı değişimi</li>
        <li>Orijinal yağ filtresi değişimi</li>
        <li>Hava filtresi temizliği veya değişimi</li>
        <li>Fren hidrolik sıvıları kontrolü ve değişimi</li>
        <li>Soğutma sıvısı (Antifriz) ölçümü</li>
        <li>Zincir temizliği ve yağlanması</li>
        <li>Lastik basınç ve diş derinliği kontrolleri</li>
      </ul>
      <p>Motorunuzun markası ne olursa olsun (Honda, Yamaha, Suzuki, Kawasaki, Bajaj vb.) servisimizde garantili bakım hizmeti alabilirsiniz.</p>
    `
  },
  {
    slug: "motor-revizyon",
    title: "Motor Revizyon (Rektifiye)",
    icon: <Gauge size={60} />,
    shortDesc: "Performans kaybı yaşayan motorları fabrika ayarlarına döndürüyoruz.",
    content: `
      <h3>Motorunuz Eski Gücüne Kavuşsun</h3>
      <p>Zamanla aşınan piston, segman, silindir ve yataklar motorunuzun performansını düşürür, yakıt tüketimini artırır ve yağ yakmaya sebep olur. Motor revizyon hizmetimizle motor bloğunuzu indiriyor, en ince vidasına kadar söküp yeniliyoruz.</p>
      
      <h3>Revizyon İşleminde Neler Yapıyoruz?</h3>
      <ul>
        <li>Kompresyon testi ve arıza tespiti</li>
        <li>Silindir kapağı taşlama ve subap alıştırma</li>
        <li>Piston ve segman seti değişimi</li>
        <li>Krank mili kontrolü ve yatak değişimi</li>
        <li>Eksantrik zinciri ve gergisi değişimi</li>
        <li>Tüm conta ve keçelerin yenilenmesi</li>
      </ul>
      <p>Kullandığımız parçalar %100 orijinal veya A kalite muadillerdir. Yaptığımız motor revizyon işlemleri 1 yıl AKC Motor garantisi altındadır.</p>
    `
  },
  {
    slug: "fren-lastik",
    title: "Fren & Lastik Değişimi",
    icon: <Disc size={60} />,
    shortDesc: "Güvenliğiniz için en kaliteli balata ve lastik hizmetleri.",
    content: `
      <h3>Hayati Önem Taşıyan İkili: Fren ve Lastik</h3>
      <p>Motosiklet kazalarının büyük bir kısmı bakımsız frenler ve eski lastikler yüzünden gerçekleşir. Can güvenliğiniz için fren balatalarınızı ve lastiklerinizi zamanında değiştirmelisiniz.</p>
      
      <h3>Hizmet Detayları</h3>
      <ul>
        <li>Brembo, EBC, Galfer balata çeşitleri</li>
        <li>Michelin, Pirelli, Anlas lastik satışı ve montajı</li>
        <li>Balans ayarı (Statik ve Dinamik)</li>
        <li>Fren hidrolik değişimi ve havasının alınması</li>
        <li>Fren kaliper bakımı ve temizliği</li>
      </ul>
    `
  },
  {
    slug: "elektrik-elektronik",
    title: "Elektrik & Elektronik Arıza",
    icon: <Zap size={60} />,
    shortDesc: "Beyin tamiri, tesisat yenileme ve arıza tespit çözümleri.",
    content: `
      <h3>Nokta Atışı Arıza Tespiti</h3>
      <p>Yeni nesil enjeksiyonlu motosikletlerde elektronik arızaları bulmak uzmanlık ister. Atölyemizde bulunan diagnostik (arıza tespit) cihazları ile motorunuzun beynine bağlanıyor, hatayı nokta atışı buluyoruz.</p>
      
      <h3>Çözdüğümüz Sorunlar</h3>
      <ul>
        <li>Akü şarj problemleri ve statör (sargı) değişimi</li>
        <li>Konjektör arızaları</li>
        <li>ABS beyni tamiri ve sensör değişimi</li>
        <li>Gösterge paneli tamiri</li>
        <li>Kopuk tesisat onarımı ve yenileme</li>
        <li>Ekstra sis farı ve çakar montajı (Tesisata zarar vermeden)</li>
      </ul>
    `
  },
 
  {
    slug: "aksesuar-montaj",
    title: "Aksesuar Montaj",
    icon: <Wrench size={60} />,
    shortDesc: "Koruma demiri, çanta ve aydınlatma montajı.",
    content: `
      <h3>Motorunuzu Kişiselleştirin</h3>
      <p>Motorunuzu hem korumak hem de daha şık göstermek için aksesuar montajı yapıyoruz. Yanlış yapılan montajlar tesisata zarar verebilir veya yolda gevşeyebilir. Bu yüzden profesyonel montaj şarttır.</p>
      
      <h3>Montaj Hizmetlerimiz</h3>
      <ul>
        <li>Koruma demiri ve takoz montajı</li>
        <li>Arka ve yan çanta demiri montajı</li>
        <li>Telefon tutucu ve USB şarj soketi</li>
        <li>Elcik ısıtma sistemleri</li>
        <li>Tur camı ve rüzgar saptırıcılar</li>
      </ul>
    `
  }
];